<template>
  <svg class="modern-icon" viewBox="0 0 24 24" aria-hidden="true">
    <g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <template v-if="name === 'calendar'">
        <rect x="3" y="5" width="18" height="16" rx="2"/><path d="M7 3v4M17 3v4M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"/>
      </template>
      <template v-else-if="name === 'coins'">
        <ellipse cx="12" cy="6" rx="7" ry="3"/><path d="M5 6v4c0 1.7 3.1 3 7 3s7-1.3 7-3V6M5 10v4c0 1.7 3.1 3 7 3s7-1.3 7-3v-4M5 14v4c0 1.7 3.1 3 7 3s7-1.3 7-3v-4"/>
      </template>
      <template v-else-if="name === 'user'">
        <circle cx="12" cy="7" r="4"/><path d="M4 21c.7-4.3 3.4-7 8-7s7.3 2.7 8 7"/>
      </template>
      <template v-else-if="name === 'phone'">
        <path d="M7.3 3.5 10 7.8 7.9 10c1.4 3 3.3 4.9 6.3 6.3l2.1-2.1 4.3 2.7-.8 3.7c-.2.9-1 1.5-1.9 1.4C9.7 21 3 14.3 2 6.1c-.1-.9.5-1.7 1.4-1.9l3.9-.7Z"/>
      </template>
      <template v-else-if="name === 'telegram'">
        <path d="m3 11 17-7-4 16-5-5-3 3v-5l8-6-10 5-3-1Z"/>
      </template>
      <template v-else-if="name === 'email'">
        <rect x="3" y="5" width="18" height="14" rx="2"/><path d="m4 7 8 6 8-6"/>
      </template>
      <template v-else-if="name === 'tag'">
        <path d="M3 12 12 3h7l2 2v7l-9 9-9-9Z"/><circle cx="16.5" cy="7.5" r="1"/>
      </template>
      <template v-else-if="name === 'comment'">
        <path d="M4 4h16v13H9l-5 4V4Z"/><path d="M8 9h.01M12 9h.01M16 9h.01"/>
      </template>
    </g>
  </svg>
</template>

<script>
export default { props: { name: String } };
</script>

<style scoped>
.modern-icon { width: 24px; height: 24px; overflow: visible; color: #f1f1f1; }
</style>
